<div class="header" #header [class.force-collapsed]="shouldForceHideNavigation" *transloco="let t;">
  <button class="menu-toggle-button" [class.force-show]="shouldForceHideNavigation"(click)="openMobileSidebar()" [attr.aria-label]="t('header.toggle_menu_button_aria_label')">
    <cwo-icon class="menu-icon" [name]="iconNameType.hamburger" aria-hidden="true"></cwo-icon>
  </button>
  <div class="header-primary-group" #headerPrimaryGroup>
    <cwo-header-logo [staticSiteUrl]="store?.staticSiteUrl ?? ''" [logoRedirectToStaticSite]="!!store?.logoRedirectToStaticSite" [src]="store?.logo" [altText]="store?.altText" [alignCenter]="layout.mobileView()"></cwo-header-logo>
    <nav class="main-navigation" [class.force-hide]="shouldForceHideNavigation" #mainNavigation>
      <cwo-header-navigational-button [label]="t('header.menu')" [target]="storeIdService.getRoutePathSegments(['menu'])"></cwo-header-navigational-button>
      <cwo-header-navigational-button [label]="t('header.my_orders')" [target]="storeIdService.getRoutePathSegments(['account', 'my-orders'])"></cwo-header-navigational-button>
      @if(!!store!.hasLoyalty && !store!.hasThirdPartyLoyalty && !!loyalty?.id){
        <cwo-header-navigational-button [label]="loyalty?.loyaltyPlanName ?? t('header.rewards')" [target]="storeIdService.getRoutePathSegments(['loyalty'])"></cwo-header-navigational-button>
        @if(premiumService.subscriptions().length) {
          <cwo-header-navigational-button [label]="t('header.premium')" [target]="storeIdService.getRoutePathSegments(['premium'])"></cwo-header-navigational-button>
        }
      }
      @if(headerFeaturedContentLinks.length) {
        @for (featuredContent of headerFeaturedContentLinks; track $index) {
          @for (featuredItem of featuredContent.featuredItems ?? []; track $index) {
            <cwo-header-navigational-button [label]="featuredItem.title ?? ''" [link]="featuredItem?.link ?? ''"></cwo-header-navigational-button>
          }
        }
      }
    </nav>
  </div>
  <div class="header-secondary-group" #headerSecondaryGroup>
    @if(store?.hasStoreChooser || store?.phone) {
      <cwo-store-info
        [class.force-hide]="shouldForceHideStoreInfo"
        [storeLabel]="store?.hasStoreChooser ? (store?.address ?? '') : ''"
        [storePhoneNumber]="store?.phone ?? ''"
      />
    }
    @if(!isCheckout){
      @if(isSelfOrder()) {
        <span class="order-details self-order-type">{{ orderTypeLabel() }}</span>
      } @else {
        <cwo-order-details-button [storeInfoStyle]="layout.storeInfoStyleView()" class="order-details"></cwo-order-details-button>
      }
    }
    <cwo-account-button (buttonPressed)="accountButtonCallback()"></cwo-account-button>
    @if(!isCheckout){
      @if (layout.state().viewport === 'mobile') {
        <cwo-view-order-button-round [itemCount]="order().itemsCount ?? 0" (click)="openCart()"></cwo-view-order-button-round>
      } @else{
        <cwo-view-order-button [itemCount]="order().itemsCount ?? 0" (click)="openCart()"></cwo-view-order-button>
      }

    }
  </div>
</div>